export const IkeDateDay = {
	Sunday: 0 as const,
	Monday: 1 as const,
	Tuesday: 2 as const,
	Wednesday: 3 as const,
	Thursday: 4 as const,
	Friday: 5 as const,
	Saturday: 6 as const,
};
export type IkeDateDay =
	| typeof IkeDateDay.Sunday
	| typeof IkeDateDay.Monday
	| typeof IkeDateDay.Tuesday
	| typeof IkeDateDay.Wednesday
	| typeof IkeDateDay.Thursday
	| typeof IkeDateDay.Friday
	| typeof IkeDateDay.Saturday;

export class IkeDate {
	/** Common time intervals in milliseconds */
	static Interval = {
		/** One day in ms */
		Day: 24 * 60 * 60 * 1000,
		/** One hour in ms */
		Hour: 60 * 60 * 1000,
		/** One minute in ms */
		Minute: 60 * 1000,
		/** One second in ms */
		Second: 1000,
	};

	/** Day offset used for date functions */
	static Day = IkeDateDay;

	/**
	 * Get the last occurrence of the weekday to the provided day,
	 * Example:
	 *  Thursday near 2019-01-09 => 2019-01-03
	 *
	 * Usage:
	 *  IkeDate.getClosestDay(new Date.UTC(2019,0,10), IkeDate.Day.Thursday) // Thursday
	 *
	 * @param date Date to find closest day for, Must be in UTC
	 * @param weekday Weekday to get @see IkeDateDay
	 */
	static getLastDay(d: Date, weekday: IkeDateDay): Date {
		// Copy date so don't modify original
		const date = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
		const currentDay = date.getUTCDay();
		date.setUTCDate(date.getUTCDate() + ((weekday - currentDay - 7) % 7));
		return date;
	}

	/**
	 * Get a short UTC date string in yyyy-mm-dd
	 * @returns Date as a UTC yyyy-MM-dd
	 **/
	static getUtcYearMonthDay(date: Date): string {
		return date.toISOString().substr(0, 10);
	}

	/**
	 * Attempt to validate that a date is a real valid date
	 *
	 * @see https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
	 */
	static isValid(date: Date): boolean {
		const newDate = new Date(date);
		return newDate.toString() !== 'Invalid Date' && !isNaN(newDate.getTime());
	}
}
